import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface ISourceInfo {
    imageUrl: string;
    sourceUrl: string;
    username: string;
}

const SourceInfo: React.FC<ISourceInfo> = (props) => {
    const { t } = useTranslation();

    return (
        <div>
            <OverlayTrigger
                trigger="click"
                placement="top"
                overlay={
                    <Popover id="popover-basic">
                        <Popover.Body>
                            <strong>{t("components.feature.sourceInfo.recipe")}: </strong>
                            <br />
                            <a href={props.sourceUrl}>{props.sourceUrl}</a>
                            <br />
                            <strong>{t("components.feature.sourceInfo.image")}: </strong>
                            <br />
                            <a href={props.imageUrl}>{props.imageUrl}</a>
                        </Popover.Body>
                    </Popover>
                }
            >
                <Button variant="dark">
                    <i className="bi bi-link-45deg"></i> {t("components.feature.sourceInfo.button")}
                </Button>
            </OverlayTrigger>
        </div>
    );
};

export default SourceInfo;
